// GW一覧のラベル
export const LABELS = {
  TITLE: "GW一覧",
  BTN_REGISTER: "GW事業者登録",

  COMPANY_NAME: "事業者名",
  COMPANY_NAME_KANA: "事業者名カナ",
  SERVICE_NAME: "サービス名",
  GW_NAME: "GW名",
  CONTRACT_STATUS: "契約ステータス",
  OPERATION_PREPARATION_STATUS: "運用準備状況",

  CONNECTION_ENVIRONMENTAL: "接続環境",
  CONNECTION_ENVIRONMENTAL_UNAPPROVED: "接続環境未承認",

  IMPLEMENTATION_CONFIRMATION: "実装確認",
  IMPLEMENTATION_CONFIRMATION_UNAPPROVED: "実装確認未承認",

  IPID_PRIOR_PAYOUT: "IPID事前払出",
  IPID_PRIOR_PAYOUT_RULE_UNSET: "IPID事前払出ルール未設定",

  CONTRACT_STATUS_STOPPED: "停止中",
  CONTRACT_STATUS_NOT_STOPPED: "契約中",
  UN_APPLICATION: "未申請",
  UN_SETTING: "未設定",
  DO_SETTING: "設定済",
};
// SELECTの空行の定義
export const SELECT_BLANK = { label: "　", value: "" };
// 契約ステータス
export const CONTRACT_STATUS_LIST = [
  SELECT_BLANK,
  { label: LABELS.CONTRACT_STATUS_NOT_STOPPED, value: "0" },
  { label: LABELS.CONTRACT_STATUS_STOPPED, value: "1" },
];
// 一覧の1ページ当たりの件数
export const LIST_PAGE_SIZE = 20;

// プレースホルダーの内容
export const PLACE_HOLDERS = {
  CORP_NUMBER: "法人番号検索をしてから必要情報を入力してください。",
  CORP_NAME: "（記入例）株式会社NTTドコモ",
  CORP_KANA: "（記入例）カブシキガイシャエヌティティドコモ",
} as const;
